@if (questions$ != null) {
  <!-- SCRUM-154: formVersion changes when the selected sub-category overloads the form
       (motorcycle / scooter) - re-create the form from the new questions. -->
  @for (version of [formVersion]; track version) {
    @if (questions$ | async; as questions) {
      @if (selectedMode === null) {
        <section class="publish-mode-gate" dir="rtl" aria-labelledby="publish-mode-title">
          <header class="mode-intro">
            <span class="mode-step">שלב 2 · בחירת דרך מילוי</span>
            <h1 id="publish-mode-title">איך תרצו ליצור את המודעה?</h1>
            <p>שתי האפשרויות משתמשות באותם פרטים. אפשר לעבור ביניהן בלי לאבד תשובות.</p>
          </header>

          <div class="mode-grid">
            <button type="button" class="mode-card mode-card--adaline" (click)="selectMode('adaline', questions)">
              <span class="recommended-badge">מומלץ</span>
              <span class="mode-icon adaline-icon" aria-hidden="true">A</span>
              <span class="mode-copy">
                <strong>מילוי חכם עם Adaline</strong>
                <small>שיחה קצרה שמתקדמת אתכם שאלה אחר שאלה</small>
              </span>
              <span class="mode-benefits">
                <i><mat-icon>check</mat-icon> אותן שאלות של הטופס</i>
                <i><mat-icon>check</mat-icon> חיפוש ובחירה חכמה</i>
                <i><mat-icon>check</mat-icon> מותאם במיוחד למובייל</i>
              </span>
              <span class="mode-action">התחלה עם Adaline <mat-icon>arrow_back</mat-icon></span>
            </button>

            <button type="button" class="mode-card mode-card--manual" (click)="selectMode('manual', questions)">
              <span class="mode-icon" aria-hidden="true"><mat-icon>edit_note</mat-icon></span>
              <span class="mode-copy">
                <strong>הטופס הידני</strong>
                <small>כל השדות והסעיפים במסך אחד, בדרך המוכרת</small>
              </span>
              <span class="mode-benefits">
                <i><mat-icon>check</mat-icon> שליטה מלאה בכל הסעיפים</i>
                <i><mat-icon>check</mat-icon> מעבר מהיר בין שדות</i>
                <i><mat-icon>check</mat-icon> מתאים למי שכבר מכיר את הטופס</i>
              </span>
              <span class="mode-action">פתיחת הטופס <mat-icon>arrow_back</mat-icon></span>
            </button>
          </div>
        </section>
      } @else if (selectedMode === 'adaline') {
        <app-adaline-publish-form
          [questions]="questions"
          [categoryLabel]="categoryLabel"
          (requestManual)="selectMode('manual', questions)">
        </app-adaline-publish-form>
      } @else {
        <div class="manual-mode-toolbar" dir="rtl">
          <button type="button" (click)="chooseDifferentMode()">
            <mat-icon aria-hidden="true">swap_horiz</mat-icon>
            <span>שינוי דרך המילוי</span>
          </button>
          <button type="button" class="adaline-shortcut" (click)="selectMode('adaline', questions)">
            <span class="mini-adaline" aria-hidden="true">A</span>
            <span>המשך עם Adaline</span>
          </button>
        </div>
        <app-dynamic-form [questions]="questions"></app-dynamic-form>
      }
    }
  }
}
